import { Box, Button, Stack, Typography } from "@mui/material";

function MainContentReUse({
  primaryText = "",
  secondaryText = "",
  primaryButton = { exist: false, text: "" },
  secondaryButton = { exist: false, text: "" },
  buttonsBelowText = { exist: false, text: "" },
  smallDivider = true,
  onClick,
  children,
  headLogoBelowPadding = "26px",
}) {
  return (
    <>
      <Stack
        id="pitchers-logo-name"
        direction="row"
        alignSelf="start"
        sx={{ pb: headLogoBelowPadding }}
      >
        <Box
          component="img"
          src="/images/pitchers.png"
          sx={{ width: "42px", height: "39px", borderRadius: "6px" }}
        ></Box>
        <Typography
          variant="body2"
          sx={{
            pl: "10px",
            fontSize: "28px",
            fontWeight: "600",
            lineHeight: "33.89px",
          }}
        >
          Pitchers
        </Typography>
      </Stack>
      <Typography
        variant="body2"
        sx={{
          fontSize: "24px",
          fontWeight: "600",
          lineHeight: "29.05px",
          maxWidth: "475px",
          pb: "4px",
        }}
      >
        {primaryText}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontSize: "17px",
          fontWeight: "400",
          lineHeight: "20.57px",
        }}
      >
        {secondaryText}
      </Typography>
      {smallDivider && (
        <Box
          sx={{
            width: "32px",
            height: "4px",
            bgcolor: "#000000",
            borderRadius: "100px",
            mt: "6px",
          }}
        ></Box>
      )}
      {children}
      <Box
        sx={{
          mt: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {primaryButton.exist && (
          <Button
            variant="contained"
            sx={{
              borderRadius: "8px",
              px: "20px",
              py: "12px",
              minWidth: "auto",
              width: "auto",
              textTransform: "none",
              bgcolor: "#000000",
              color: "#FFFFFF",
              boxShadow: "0px 4px 24px 0px #315DFF3D",
              "&:hover": {
                backgroundColor: "#000000",
                boxShadow: "none",
              },
              "&:active": {
                backgroundColor: "#000000",
                boxShadow: "none",
              },
              "&:focus": {
                outline: "none",
                boxShadow: "none",
              },
            }}
            onClick={onClick}
          >
            {primaryButton.text}
          </Button>
        )}
        {secondaryButton.exist && (
          <Button
            variant="contained"
            sx={{
              borderRadius: "8px",
              px: "20px",
              py: "12px",
              minWidth: "auto",
              width: "auto",
              textTransform: "none",
              bgcolor: "#000000",
              color: "#FFFFFF",
              boxShadow: "0px 4px 24px 0px #315DFF3D",
              "&:hover": {
                backgroundColor: "#000000",
                boxShadow: "none",
              },
              "&:active": {
                backgroundColor: "#000000",
                boxShadow: "none",
              },
              "&:focus": {
                outline: "none",
                boxShadow: "none",
              },
            }}
            onClick={onClick}
          >
            {secondaryButton.text}
          </Button>
        )}
      </Box>
      {buttonsBelowText.exist && (
        <Typography
          variant="body2"
          sx={{
            fontSize: "17px",
            fontWeight: "400",
            lineHeight: "20.57px",
            pt: "16px",
          }}
        >
          {buttonsBelowText.text}
        </Typography>
      )}
    </>
  );
}

export default MainContentReUse;
